// components/main/ObjektErstellen.jsx

import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../context/AuthContext";
import { useLoadAllData } from "../../hooks/useLoadAllData";
import Navbar from '../utils/Navbar';
import ObjektErstellenForm from "./ObjektErstellenForm";

const ObjektErstellen = () => {
  const { fetchWithAuth, accessToken } = useAuth();
  const navigate = useNavigate();

  const {
    kategorien,
    ablageorte,
    typen,
    laender,
    materialien,
    waehrungen,
    zustaende,
    eigentuemer,
    loading,
    error
  } = useLoadAllData();

  const [formData, setFormData] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({ bild01: null, bild02: null });
  const [filteredZustaende, setFilteredZustaende] = useState(zustaende);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchZustaendeByKategorie = async () => {
      if (!formData.kategorie) {
        setFilteredZustaende(zustaende);  // alle anzeigen, wenn keine Kategorie gewählt
        return;
      }

      try {
        const response = await fetchWithAuth(
            `/api/data/zustaende/?kategorie=${formData.kategorie}`,
        );
        if (response.ok) {
          const data = await response.json();
          setFilteredZustaende(data);
        } else {
          console.error("Fehler beim Laden der Zustände");
        }
      } catch (err) {
        console.error("Fetch-Fehler:", err);
      }
    };

    fetchZustaendeByKategorie();
  }, [formData.kategorie, accessToken]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // convert date to ISOString for a correct transmission
    const isDate = value instanceof Date;
    setFormData((prev) => ({
      ...prev,
      [name]: isDate ? value.toISOString().split("T")[0] : value,
    }));
  };

  const handleImageChange = (name, file) => {
    setSelectedFiles(prev => ({ ...prev, [name]: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formPayload = new FormData();

      // text fields
      for (const key in formData) {
        if (formData[key] !== null && formData[key] !== undefined) {
          formPayload.append(key, formData[key]);
        }
      }

      // images
      if (selectedFiles.bild01) {
        formPayload.append("bild01", selectedFiles.bild01);
      }
      if (selectedFiles.bild02) {
        formPayload.append("bild02", selectedFiles.bild02);
      }

      const response = await fetchWithAuth(`/api/main/add/`, {
        method: "POST",
        // now content type here, otherwise error because formData!
        body: formPayload
        // body: JSON.stringify(formPayload)
      });

      if (!response.ok) {
        const errData = await response.json();
        // console.error("Fehler beim Erstellen:", errData);
        throw new Error("Fehler beim Erstellen");
      }

      navigate("/objekte");
    } catch (err) {
      setErrorMessage("Speichern fehlgeschlagen: " + err.message);
    }
  };

  if (loading) return <p>Lade Daten...</p>;
  if (error) return <p className="text-danger">Fehler: {error}</p>;

  return (
    <>
      <Navbar />
      <ObjektErstellenForm
        formData={formData}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        handleImageChange={handleImageChange}
        errorMessage={errorMessage}
        kategorienData={kategorien}
        ablageorteData={ablageorte}
        typenData={typen}
        laenderData={laender}
        materialienData={materialien}
        waehrungenData={waehrungen}
        zustaendeData={filteredZustaende}
        eigentuemerData={eigentuemer}
      />
    </>
  );
};

export default ObjektErstellen;
